import getters from "./getters";
import actions from "./actions";
import mutations from "./mutations";

const state = {
 notifications: [],
 notification: {},
 upgradeNotifications: [],
 notificationsLoading: false,
 upgradeNotiMeta: {},
 systemNotiMeta: {}
};

export default {
  state,
  getters,
  mutations,
  actions,
  namespaced: true
};
